module.exports = __webpack_public_path__ + "assets/media/coins-history.009766d7.svg";